import React, { useState } from 'react';
import {
    Text, Stack, Link, PersonaSize, Persona, PersonaPresence,
    Dialog, DialogFooter, PrimaryButton, DefaultButton, DialogType, Image, ImageFit
} from '@fluentui/react';
import { useSelector, useDispatch } from "react-redux";
import URL from "../../Containers/MainController";
import Type from "../../Redux/Type";
import { onCloseRightPanel, onOpenRightPanel } from "../../Containers/RightPanelAction";
import TNH_SETUP from '../../Containers/setup';


const Account = () => {
    const dispatch = useDispatch();
    const [hideDialog, setHideDialog] = useState(true);
    const userInfo = useSelector(state => state.userInfo)

    const onHideDialog = () => setHideDialog(true);
    const onShowDialog = () => setHideDialog(false);

    const onSignOut = () => {
        localStorage.removeItem(URL.token);
        dispatch({ type: Type.SET_TOKEN, token: '' })
        dispatch({ type: Type.SET_USER_INFO, userInfo: '' });
        onCloseRightPanel();
    }

    const onChangePasswordPress = () => onOpenRightPanel('changePassword')


    return (
        <div className='modal-content-container'>
            <div className='animated-panel'>
                <Stack horizontalAlign='center' styles={styles.container} tokens={{ childrenGap: 16 }}>
                    <Persona
                        text={userInfo.FullName}
                        size={PersonaSize.size72}
                        presence={PersonaPresence.online}
                        hidePersonaDetails={true}
                    />
                    <Stack horizontalAlign='center' tokens={{ childrenGap: 5 }}>
                        <Text variant='mediumPlus'>{userInfo.FullName}</Text>
                        <Text variant='medium'>{userInfo.Username}</Text>
                    </Stack>
                    <Stack tokens={{ childrenGap: 5 }} horizontalAlign='center'>
                        <Link onClick={onChangePasswordPress}>Đổi mật khẩu</Link>
                        <Link onClick={onShowDialog}>Đăng xuất</Link>
                    </Stack>
                    {/* <Stack >
                        <Text style={{ textAlign: 'center', color: 'gray' }}>Tải ứng dụng VNPT-ILIS để có trải nghiệm tốt hơn trên thiết bị di động.</Text>
                        <Stack style={{ flexDirection: 'row', marginTop: 10, justifyContent: 'center' }}>
                            <a href={TNH_SETUP.urlMobile.urlIos}>
                                <Image
                                    src={process.env.PUBLIC_URL + '/images/icons/iphone-app-download.png'}
                                    imageFit={ImageFit.contain}
                                    width={100}
                                    height={40}
                                />
                            </a>
                            <Stack style={{ width: 30 }} />
                            <a href={TNH_SETUP.urlMobile.urlAndroid}>
                                <Image
                                    src={process.env.PUBLIC_URL + '/images/icons/logo-google-play.png'}
                                    imageFit={ImageFit.contain}
                                    width={100}
                                    height={40}
                                />
                            </a>
                        </Stack>
                    </Stack> */}
                </Stack>
            </div>
            <Dialog
                hidden={hideDialog}
                onDismiss={onHideDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Đăng xuất',
                    closeButtonAriaLabel: 'Đóng',
                    subText: 'Bạn có muốn đăng xuất tài khoản ?',
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={onSignOut} text="Đăng xuất" />
                    <DefaultButton onClick={onHideDialog} text="Hủy bỏ" />
                </DialogFooter>
            </Dialog>
        </div>
    )
};

export default Account;

const styles = {
    container: {
        root: {
            marginTop: 30,
        }
    }
};

